import { StudentSubscription } from 'modules/arena/subscriptions/types';
import { SUBSCRIPTION_STATUS_LABELS } from 'modules/arena/subscriptions/content';
import { Badge } from 'shared/components/ui/Badge';
import { cn } from 'shared/utils/cn';

const STATUS_TONE = {
  ativa: 'success',
  pendente_pagamento: 'warning',
  cancelada: 'danger',
  expirada: 'neutral',
} as const;

interface SubscriptionRowProps {
  subscription: StudentSubscription;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export function SubscriptionRow({ subscription, isSelected, onSelect }: SubscriptionRowProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect(subscription.id)}
      className={cn(
        'flex w-full flex-col gap-1 rounded-xl border p-4 text-left transition-colors',
        isSelected ? 'border-primary bg-accent-soft/30' : 'border-border/40 hover:border-primary'
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-ink">{subscription.studentName}</span>
        <Badge tone={STATUS_TONE[subscription.status]}>{SUBSCRIPTION_STATUS_LABELS[subscription.status]}</Badge>
      </div>

      <p className="text-sm text-ink-secondary">
        {subscription.classGroupName} · {subscription.sport}
      </p>

      <div className="mt-1 flex items-center justify-between text-sm">
        <span className="font-medium text-ink">R$ {subscription.monthlyPrice}/mês</span>
        {subscription.status === 'ativa' && (
          <span className="text-xs text-ink-secondary">próx. cobrança {subscription.nextBillingLabel}</span>
        )}
      </div>
    </button>
  );
}
